<template>
    <div class="detailAudio-view">
        <div ref="detailAudioBodyWrapper" class="detailAudio-body-wrapper">
            <div class="detailAudio-body">
                <div class="baseInfo-qrcode-mask">
                    <div class="baseInfo-mask">
                        <div class="catelog-body">
                            <video-player  class="video-player-box"
                                             ref="videoPlayer"
                                             :options="playerOptions"  :playsinline="true"
                                             :preload="'none'">
                            </video-player>
                        </div>   
                    </div>
                    <div class="cateloglist">
                       <h5 class="cateloglist_title">{{baseInfo.Name}}</h5>
                       <div class="cateloglist_scroll" ref="catelogBodyWrapper">
                            <div >
                               <ul>
                                    <li v-for="(item,index) in catelogList">
                                        <a @click="goPlayer(item.ID,item.Sequence)" :style="{cursor:'pointer',color:(item.Sequence==currentSequence?themeColor:'')}">{{item.Title}}
                                        </a>
                                    </li>
                               </ul>
                            </div>
                       </div>
                    </div>
                </div>
                <div class="catelog-rec-mask" v-if="$route.params.cateCode">
                    <div class="rec-mask">
                        <h5 class="rec-header">
                            {{ langTransfer('猜你喜欢') }}
                        </h5>
                        <div class="rec-body">
                            <div v-for="(item,index) in userLikeList"
                                 :key="index"
                                 class="rec-item"
                                 @click="goDetail(item)">
                                <img :src="item.__cover">
                                <div class="rec-item-infos">
                                    <h5>{{ item.Name }}</h5>
                                    <span :title="item.__bottomInfo">{{ item.__bottomInfo }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="width: 100%;height: 20px;"/>
                <div class="site-footer">
                            <Footer/>
                </div>
            </div>
        </div>
        <backBtn/>
    </div>
</template>

<script>
    import BScroll from 'better-scroll'
    import QRCode from 'qrcodejs2'
    import 'video.js/dist/video-js.css'
    import { videoPlayer } from 'vue-video-player'
    import backBtn from '@/components/backBtn'
    import Footer from '@/components/footer'
    export default {
        components: {
            videoPlayer,
            backBtn,
            Footer
        },
        data () {
            return {
                currentSequence:'',
                detailAudioBScroll: null,
                catelogBodyBScroll:null,
                cateName: 'cateName',
                sortIndex: -1,
                baseInfo: {},
                catelogList: [],
                isPlayingIndex: -1,
                userLikeList: [],
                lastParams: {},
                hoverCateIndex: -1,
                bookCaseId: undefined,
                isPending: true,
                playerOptions: {
                      autoplay: true,
                      height: '420',
                      width:'850',
                      language: 'zh-CN',
                      playbackRates: [0.7, 1.0, 1.5, 2.0],
                      sources: [{
                        type: "video/mp4",
                        //src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
                        src:''
                      }],
                      poster: "",
                      notSupportedMessage: '等待播放,如长时间没有反应,请刷新页面重新观看' 
                }
            }
        },
        computed: {
            types () {
                const { resourceType } = this
                return this.allTypes[resourceType]
            },
            detailAudioListClassName () {
                const { resourceType } = this
                return {
                    'audio-likely': resourceType === 'audio',
                    'book-likely': resourceType === 'book',
                    'magazine-likely': resourceType === 'magazine'
                }
            },
            catelogListData () {
                const { catelogList, sortIndex } = this
                if (catelogList.length <= 0 || !sortIndex) {
                    return []
                }
                return catelogList.sort(() => {
                    return -1
                })
            },
            playingSequence () {
                return this.$store.state.playingSequence
            },
            themeColor () {
                return this.$store.state.themeColor
            },
            isNexus () {
                return this.$store.state.isNexus
            }
        },
        activated () {
        },
        mounted () {
            this.initBScroll()
            this.$store.commit('setPlayerBaseData', undefined)
        },
        methods: {
            initBScroll () {
                this.$nextTick(() => {
                    this.detailAudioBScroll = new BScroll(this.$refs.detailAudioBodyWrapper, {
                        bounce: false,
                        click: true,
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 300
                        }
                    });
                    this.catelogBodyBScroll = new BScroll(this.$refs.catelogBodyWrapper, {
                        bounce: false,
                        click: true,
                        momentum: false,
                        stopPropagation: true,
                        mouseWheel: {
                            speed: 20,
                            invert: false,
                            easeTime: 0
                        }
                    })
                })
            },
            initQrCode (text) {
                const ele = this.$refs.qrcode
                ele.innerHTML = ''
                this.qrcode = new QRCode(ele, {
                    width: 222,
                    height: 222,
                    text
                })
            },
            async getShortQCUrl (shortCode) {
                try {
                    const data = await this.$apis('shortQC').getShortQCUrl(shortCode)
                    if (data) {
                        this.initQrCode(data)
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async getDetailInfo (params) {
                try {
                    const {
                        id,sequence
                    } = params
                    let { Data } = await this.$apis('video').getDetailInfo(id);
                    [Data] = this.$tools.formatVideoData([Data], true)
                    this.baseInfo = Data
                    
                    try
                    {
                        let downdata = await this.$apis('video').getSubResUrl(id,sequence);
                         this.playerOptions.poster = this.baseInfo.ImageUrl;
                         this.playerOptions.sources[0].src= downdata.Data;
                    }catch(error)
                    {
                        const { Code } = error
                        if (Code === 4) {
                            this.playerOptions.notSupportedMessage ='请登陆后观看视频';
                            this.$store.commit('setShowLoginRegister', true)
                        }
                        this.$tools.checkBindMobile(Code);
                    }

                    this.$nextTick(() => {
                        this.getShortQCUrl(Data.ShortCode)
                    })
                } catch (error) {
                    console.log(error)
                }
            },
            async getDetailCatelog (params) {
                try {
                    this.isPending = true
                    const {
                        id
                    } = params
                    const { Data } = await this.$apis('video').getCatelog(id)
                    if (!Data) {
                        this.catelogList = []
                        return
                    }
                    this.catelogList = Data.map((e) => {
                        e.__duration = this.$tools.formatTime(e.Duration, true)
                        return e
                    })
                    this.isPending = false
                } catch (error) {
                    console.log(error)
                }
            },
            async getUserLike (params) {
                try {
                    const {
                        id, cateCode
                    } = params
                    const pageSize = 11
                    const pageIndex = 1
                    const { Data } = await this.$apis('video')
                        .getListByCate(cateCode, pageIndex, pageSize)
                    const __arr = Data.filter((e) => {
                        return e.ID !== id
                    }).slice(0, 10)
                    this.userLikeList = this.$tools.formatVideoData(__arr)
                } catch (error) {
                    console.log(error)
                }
            },
            async goPlayer (id,s) {
                /*const { catelogList, baseInfo } = this
                const { playerBaseData } = this.$store.state
                let { playerCateLogList } = this.$store.state

                let catelog
                let sequence
                if (index === 'all') {
                    catelog = catelogList
                    sequence = catelogList[0].Sequence
                } else {
                    catelog = [catelogList[index]]
                    sequence = catelogList[index].Sequence
                }

                const oldId = playerBaseData ? playerBaseData.id : undefined
                if (oldId !== baseInfo.ID) {
                    const baseData = {
                        id: baseInfo.ID,
                        name: baseInfo.Name,
                        cover: baseInfo.ImageUrl
                    }
                    this.$store.commit('setPlayerBaseData', baseData)
                    playerCateLogList = []
                }

                if (playerCateLogList.length > 0 && index !== 'all') {
                    if (!playerCateLogList.find((e) => {
                        return e.Sequence === catelogList[index].Sequence
                    })) {
                        catelog = playerCateLogList.concat([catelogList[index]])
                    } else {
                        catelog = playerCateLogList
                    }
                }

                this.$store.commit('setShowPlayingSequence', sequence)
                this.$store.commit('setPlayerCateLogList', catelog)*/
                this.playerOptions.poster = '';
                this.playerOptions.sources[0].src='';
                this.currentSequence =s;
                try
                {
                    let downdata = await this.$apis('video').getSubResUrl(id,s);
                     this.playerOptions.poster = this.baseInfo.ImageUrl;
                     this.playerOptions.sources[0].src=downdata.Data;
                }catch(error)
                {
                    const { Code } = error
                    if (Code === 4) {
                        this.playerOptions.notSupportedMessage ='请登陆后观看视频';
                        this.$store.commit('setShowLoginRegister', true)
                    }
                }
                
               
            },
            goDetail (item) {
                const { cateCode, cateName } = this.$route.params
                let cate
                if (cateCode !== 'cateCode' && cateName !== 'cateName') {
                    cate = {
                        CategoryCode: cateCode,
                        CategoryName: cateName
                    }
                }
                this.$tools.goDetailRoute.call(this, 'video', item, cate)
            },
            bookCaseBtnClick () {
                let userInfos
                try {
                    userInfos = this.$cookies.get('user')
                } catch (error) {
                    console.log(error)
                }
                if (!userInfos) {
                    this.$store.commit('setShowLoginRegister', true)
                    return
                }
                const { bookCaseId } = this
                if (bookCaseId !== 0) {
                    this.removeFromBookCase()
                } else {
                    this.addToBookCase()
                }
            },
            async addToBookCase () {
                try {
                    this.bookCaseId = undefined
                    const {
                        id
                    } = this.$route.params
                    const formData = {
                        resourceid: id,
                        resourcekind: 5
                    }
                    const data = await this.$apis('user').addToBookCase(formData)
                    if (data.Code === 1) {
                        this.bookCaseId = data.Data
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async removeFromBookCase () {
                try {
                    this.bookCaseId = undefined
                    const {
                        id
                    } = this.$route.params
                    const formData = {
                        resourceid: id,
                        resourcekind: 5
                    }
                    const data = await this.$apis('user').removeFromBookCase(formData)
                    if (data.Code === 1) {
                        this.bookCaseId = 0
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async isInUserBookCase (params) {
                try {
                    const { userInfos } = this.$store.state
                    if (!userInfos) {
                        return
                    }
                    const {
                        id
                    } = params
                    const res = {
                        resourceid: id
                    }
                    const { Data } = await this.$apis('user').isInUserBookCase(res)
                    this.bookCaseId = Data
                } catch (error) {
                    console.log(error)
                }
            },
            goCateRoute (all) {
                const {
                    cateCode
                } = this.$route.params
                const params = {
                    resourceType: 'video'
                }
                params.cateCode = all ? 'all' : cateCode

                this.$router.push({
                    name: 'allCates',
                    params
                })
            }
        },

        beforeRouteUpdate (to, from, next) {
            const {
                cateCode, cateName
            } = to.params
            this.baseInfo = {}
            this.catelogList = []
            this.userLikeList = []
            this.cateName = cateName
            if (this.detailPaperBScroll) {
                this.detailPaperBScroll.refresh()
                this.detailPaperBScroll.scrollTo(0, 0)
            }
            this.getDetailInfo(to.params)
            this.getDetailCatelog(to.params)
            this.isInUserBookCase(to.params)
            if (cateCode !== 'cateCode') {
                this.getUserLike(to.params)
            }
            next()
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                vm.$store.commit('setPlayerBaseData', undefined)
                const { params } = vm.$route;
                vm.currentSequence = params.sequence;
                if (vm.$tools.isSameParams(params, vm.lastParams)) {
                    return
                }
                vm.lastParams = params
                const {
                    cateCode, cateName
                } = params
                vm.baseInfo = {}
                vm.catelogList = []
                vm.userLikeList = []
                vm.cateName = cateName
                if (vm.detailPaperBScroll) {
                    vm.detailPaperBScroll.refresh()
                    vm.detailPaperBScroll.scrollTo(0, 0)
                }
                
                vm.getDetailInfo(params)
                vm.getDetailCatelog(params)
                vm.isInUserBookCase(params)
                if (cateCode !== 'cateCode') {
                    vm.getUserLike(params)
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
    .cateloglist_title{
        height: 60px;
        line-height: 60px;
        text-align: center;
        border-bottom: 1px solid rgb(236, 235, 235);
    }
    .cateloglist_scroll{
        height: 345px;
        overflow:hidden;

    }
    .vjs_video_style{

    }
    .detailAudio-view {
        width: 100%;
        height: 100%;
        margin: 0 auto;
        box-sizing: border-box;
        position: relative;
        overflow: hidden;
    }

    .detailAudio-view-header {
        width: 100%;
        height: 40px;
        box-sizing: border-box;
        background: #F6FAFF;
    }

    .crumbs-nav-mask {
        width: 1140px;
        height: 40px;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        p {
            
            font-size: 13px;
            color: #4BA8FF;
            letter-spacing: 0;
            cursor: pointer;
        }

        i {
            width: 1px;
            height: 12px;
            display: block;
            transform: rotate(20deg);
            background: #4BA8FF;
            border-radius: 100px;
            margin: 0 10px;
        }
    }

    .detailAudio-body-wrapper {
        width: 1140px;
        position: absolute;
        top: 40px;
        bottom: 0;
        left: 50%;
        right: 0;
        margin-left: -570px;
        overflow: hidden;
    }

    .detailAudio-body {
        width: 100%;
        padding-bottom: 138px;
    }

    .baseInfo-qrcode-mask {
        width: 1140px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .qrcode {
        width: 222px;
        height: 222px;
        background: #f6f6f6;
    }

    .baseInfo-mask {
        width: 850px;
        height: 420px;
        box-sizing: border-box;
        /*padding: 32px 34px;*/
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }

    .cover-info {
        width: 240px;
        height: 240px;
        border-radius: 4px;
        background: #f6f6f6;
    }

    .text-infos {
        width: 518px;
        height: 240px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        position: relative;

        h5 {
            
            font-size: 24px;
            color: #1A1A1A;
            line-height: 24px;
        }

        span {
            
            font-size: 16px;
            color: #8590A6;
            line-height: 16px;
            margin: 10px 0 16px;
        }

        .third-platform-shares {
            height: 36px;
            padding-left: 2px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            opacity: 0;

            img {
                width: 28px;
                height: 28px;
                margin-right: 7px;
                border-radius: 50%;
            }
        }

        p {
            height: 60px;
            
            font-size: 14px;
            color: #79808B;
            letter-spacing: 0;
            line-height: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            margin: 16px 0 24px;
        }

        .actives {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            .playAll-icon {
                width: 38px;
                height: 38px;
                border-radius: 50%;
                margin-right: 16px;
                cursor: pointer;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
            }

            img {
                width: 20px;
                height: 20px;
                margin-left: 2px;
            }

            i {
                font-style: normal;
                
                font-size: 16px;
                color: #1A1A1A;
                letter-spacing: 0;
                text-align: center;
                line-height: 16px;
                cursor: pointer;
            }
        }

        .addto-bookCase {
            position: absolute;
            right: 0;
            bottom: 10px;
            
            font-size: 14px;
            color: #0084FF;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
        }
    }

    .cateloglist {
        width: 270px;
        height: 420px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
        /*display: flex;
        flex-direction: column;
        justify-content: center;*/
        align-items: center;

        ul{
            list-style:none;
            padding-left: 24px;
            li{
                height: 40px;
                display: block;
                line-height: 40px;
                overflow: hidden;
            }
        }

        p {
            
            font-size: 14px;
            color: #79808B;
            letter-spacing: 0;
            text-align: center;
            line-height: 14px;
            margin-top: 20px;
        }
    }

    .catelog-rec-mask {
        margin-top: 20px;
        width: 1140px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }

    .catelog-mask {
        width: 850px;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .catelog-header {
        width: 100%;
        height: 50px;
        box-sizing: border-box;
        padding: 0 16px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #F0F2F7;

        .header-name {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
        }

        .warning-icon {
            display: block;
            width: 4px;
            height: 16px;
            margin-right: 8px;
            background: #0084FF;
            border-radius: 2px;
        }

        .header-active-sort {
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;

            p {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 50px;
                cursor: pointer;
            }

            .mid-line {
                width: 1px;
                height: 16px;
                margin: 0 8px;
                background: #8590A6;
            }
        }
    }

    .catelog-body {
        width: 100%;
        box-sizing: border-box;
        /*padding: 8px 16px;*/
    }

    .catelog-item {
        width: 100%;
        height: 40px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        i {
            display: block;
            width: 66px;
            text-align: center;
            font-style: normal;
            
            font-size: 14px;
            color: #1A1A1A;
            line-height: 40px;
            background-repeat: no-repeat;
            background-position: center center;
            background-size: 12px 14px;
        }

        h5 {
            width: 632px;
            
            font-size: 14px;
            color: #1A1A1A;
            line-height: 40px;
        }

        span {
            display: block;
            width: 140px;
            box-sizing: border-box;
            padding-right: 16px;
            
            font-size: 14px;
            color: #8590A6;
            text-align: right;
            line-height: 14px;
            text-align: right;
        }

        .isplaying-animation {
            width: 66px;
            box-sizing: border-box;
            padding: 0 26px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;

            .animation-item {
                display: block;
                width: 2px;
                height: 18px;
                background: #0084FF;
                border-radius: 1px;
            }

            .animation-item:nth-child(1){
                animation: living .8s linear .1s infinite normal;
                height: 18px;
            }
            .animation-item:nth-child(2){
                animation: living .8s linear .3s infinite normal;
                height: 18px;
            }
            .animation-item:nth-child(3){
                animation: livingBack .8s linear .1s infinite normal;
                height: 8px;
            }
            .animation-item:nth-child(4){
                animation: livingBack .8s linear .3s infinite normal;
                height: 8px;
            }

            @keyframes living{
                0%{height: 18px}
                50%{height: 8px}
                100%{height: 18px}
            }

            @keyframes livingBack{
                0%{height: 8px}
                50%{height: 18px}
                100%{height: 8px}
            }
        }

        .hover-svg-mask {
            width: 66px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
        }
    }

    .catelog-item:hover {
        background: #F6F6F6;

        h5 {
            color: #0084FF;
        }
    }

    .rec-mask {
        width: 100%;
        background: #FFFFFF;
        box-shadow: 0 1px 3px 0 rgba(26,26,26,0.10);
        border-radius: 2px;
    }

    .rec-header {
        width: 100%;
        height: 50px;
        box-sizing: border-box;
        padding-left: 16px;
        border-bottom: 1px solid #F0F2F7;
        
        font-size: 16px;
        color: #1A1A1A;
        line-height: 50px;
    }

    .rec-body {
        padding: 8px 0;

        .rec-item {
            height: 74px;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;

            img {
                width: 50px;
                height: 50px;
                display: block;
                margin: 0 16px;
            }
        }

        .rec-item-infos {
            height: 50px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;

            h5 {
                
                font-size: 16px;
                color: #1A1A1A;
                line-height: 16px;
                max-width: 172px;
            }

            span {
                display: block;
                
                font-size: 14px;
                color: #8590A6;
                line-height: 14px;
                margin-top: 8px;
                max-width: 172px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }

        .rec-item:hover {
            background: #F6F6F6;
        }
    }

    .site-footer {
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: none;
    }

    .player-wrapper {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start
    }

    .lock-icon {
        width: 20px;
        height: 20px;
        background: saddlebrown;
        align-self: flex-end;
        margin-right: 50px;
    }

    .player-body-mask {
        width: 100%;
        margin: 0 auto;
        background: red;
        height: 0;
        overflow: hidden;
        transition: height .2s;
    }

    .player-body-mask.fix-height {
        height: 80px;
    }

    .player-body {
        height: 100%;
        width: 1140px;
        margin: 0 auto;
        background: yellowgreen;
    }

    .player-wrapper:hover {

        .player-body-mask {
            height: 80px;
        }
    }

    .loader {
        width: 100%;
        height: 90px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }
</style>
